import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { section6Validation } from "../../Constant/constant";
import Spinner from "../../Layouts/Spinner";
import { addSection6Data } from "../../../redux/cms/action";

const Section6Add = () => {
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: "",
      ar_title: "",
      sub_title: "",
      ar_sub_title: "",
      //   image:section1Data?.image||""
    },
    validationSchema: section6Validation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    try {
      const data = {
        ...values,
        section: 8,
      };
      dispatch(addSection6Data(data, setLoading, navigate));
    } catch (error) {
      console.error("Submit Error:", error);
    }
  };

  return (
    <div className=" category-wrapper">
      <form onSubmit={formik.handleSubmit}>
        <div className="d-flex justify-content-between align-items-center pb-5">
          <h3>Section - 8</h3>
          <div
            className="d-flex align-items-center justify-content-center   "
            style={{ columnGap: "20px" }}
          >
            <button
              className="submit-btn   "
              style={{ width: "max-content" }}
              type="submit"
            >
              {!loading ? "Add" : <Spinner />}
            </button>
          </div>
        </div>
        <div className="box-shadowsec">
          <div className="row ">
            <div className="col-md-12 form-group">
              <label>Title</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter title"
                name="title"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.title}
              />
              {formik.touched.title && formik.errors.title ? (
                <div className="error">{formik.errors.title}</div>
              ) : null}
            </div>
            <div className="col-md-12 form-group">
              <label>Sub Title</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter sub title"
                name="sub_title"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.sub_title}
              />
              {formik.touched.sub_title && formik.errors.sub_title ? (
                <div className="error">{formik.errors.sub_title}</div>
              ) : null}
            </div>
            <div className="col-md-12 form-group">
              <label>Ar Title</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter ar title"
                name="ar_title"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.ar_title}
              />
              {formik.touched.ar_title && formik.errors.ar_title ? (
                <div className="error">{formik.errors.ar_title}</div>
              ) : null}
            </div>
            <div className="col-md-12 form-group">
              <label>Ar Sub Title</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter ar sub title"
                name="ar_sub_title"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.ar_sub_title}
              />
              {formik.touched.ar_sub_title && formik.errors.ar_sub_title ? (
                <div className="error">{formik.errors.ar_sub_title}</div>
              ) : null}
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Section6Add;
